import { render } from "./MainMenu.vue?vue&type=template&id=6d380f92&scoped=true"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"

import "./MainMenu.vue?vue&type=style&index=0&id=6d380f92&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/puchtrade-project/puchtrade/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d380f92"]])

export default __exports__